<template>
	<div class="o-dashboard">

		<div class="o-dashboard__breadcrumbs" v-if="client">
			<ul class="c-breadcrumbs">
				<li> <a href="/">Dashboard</a> </li>
				<li> <span>{{client.name}}</span> </li>
			</ul>
		</div>

		<div class="o-dashboard__panels" v-if="client">
			<div class="row collapse">

				<div class="column small-12 xlarge-8">

					<c-block-company-info
						:client="client">
					</c-block-company-info>
				</div>

				<div class="column small-12 xlarge-4">

					<c-block-addressbook v-if="client.addresses"
						@added="load"
						:addresses="client.addresses"
						:client_name="client.name"
						:client_id="client.id"/>

					<div v-if="client.client_type_id == $constants.client.EINDGEBRUIKER">
						<c-block-activity :client_id="client.id" :activities="client.events" />
					</div>
				</div>

				<div class="column small-12 xlarge-12" v-if="user.contact.client.client_type_id !== $constants.client.EINDKLANT">

					<c-block-stock v-if="client.client_type_id == $constants.client.EINDKLANT "
						:endpoint="'/api/getproductsbyclientid/' + client.id"
						:client_type_id="client.client_type_id"
					></c-block-stock>

					<c-block-inactive-stock v-if="client.client_type_id == $constants.client.EINDKLANT"
						:endpoint="'/api/inactive-products/' + client.id"
						:client_type_id="client.client_type_id"
						@openModalStock="openModalInactiveStock()"
					></c-block-inactive-stock>

					<c-block-stock v-if="client.client_type_id == $constants.client.EINDGEBRUIKER"
						:endpoint="'/api/getitemsbyclientid/' + client.id"
						:client_type_id="client.client_type_id"
					></c-block-stock>

					<c-block-product-prices v-if="client.client_type_id == $constants.client.EINDKLANT && can('Factuur beheren')"
						:endpoint="'/api/getproductsbyclientid/' + client.id"
						:client_type_id="client.client_type_id"
						@openModal="openModalPrice()"
					></c-block-product-prices>
				</div>

				<div class="column small-12" v-if="client.client_type_id == $constants.client.EINDKLANT && user.contact.client.client_type_id !== $constants.client.EINDKLANT">
					<c-block-prenotifications :testRows="client.asns" />
				</div>

				<div class="column small-12" v-if="client.client_type_id == $constants.client.RESELLER">

					<c-block-customers 
						:endpoint="'/api/getendclientsbyparentid/' + client.id"
						:client_type_id="$constants.client.EINDKLANT"
						:title="'Eindklanten'">
					</c-block-customers>

				</div>

				<div class="column small-12" v-if="client.client_type_id == $constants.client.EINDKLANT && user.contact.client.client_type_id !== $constants.client.EINDKLANT">
					
					<c-block-customers 
						:endpoint="'/api/getendclientsbyparentid/' + client.id"
						:client_type_id="$constants.client.EINDGEBRUIKER"
						:title="'Eindgebruikers'">
					</c-block-customers>

				</div>
			</div>
		</div>

		<c-new-stock
			v-if="modalStock"
			@close="modalStock=false"
			:size="'medium'"/>

		<c-new-prenotification
			v-if="modalPrenotification"
			@close="modalPrenotification=false"
			:size="'medium'"
			:title="'Nieuwe voormelding'"/>

		<c-new-customer v-if="client && modalNewCustomer"
			v-show="modalNewCustomer"
			@close="modalNewCustomer=false"
			@added="load"
			:size="'medium'"
			:edit="true"
			:contact="contact"
			:client="client"
			title="Wijzig"
			:client_type_id="client.client_type_id.toString()"/>

		<c-new-resignation  v-if="client && modalResignation"
			:addresses="deliveryAddresses"
			:contacts="client.contacts"
			:contact="client.contacts[0]"
			:items="items"
			v-show="modalResignation"
			@close="modalResignation=false"
			@added="load"
			:size="'medium'"/>

		<c-repair-request v-if="client && modelRepair"
			v-show="modelRepair"
			:items="items"
			:addresses="deliveryAddresses"
			:parent_client_id="client.parent_client_id"
			:client_id="client.id"
			@close="modelRepair=false"
			:size="'medium'"/>

        <c-new-address
			v-if="client && modelNewAddress"
			:client_id="client.id"
			v-show="modelNewAddress"
			@close="modelNewAddress=false"
			@added="load"
			:size="'medium'"/>

		<c-eol-swap v-if="client && modalEOl"
			v-show="modalEOl"
			:items="items"
			:addresses="deliveryAddresses"
			:parent_client_id="client.parent_client_id"
			:client_id="client.id"
			@close="modalEOl=false"
			:size="'medium'"/>

		<c-order-extra-products v-if="client && modalExtraProducts"
			v-show="modalExtraProducts"
			:client="client"
			@close="modalExtraProducts=false"
			:size="'medium'"
			:addresses="deliveryAddresses"/>

        <c-import-addresses
            v-show="modalImportAddresses"
            @close="modalImportAddresses=false"
            @added="load"
            :size="'medium'"
            :title="'Importeer Adressen'">
        </c-import-addresses>

		<c-monthly-payments v-if="client.monthly_payments"
			v-show="modalMonthlyPayments"
            @close="modalMonthlyPayments=false"
            @added="load"
            :size="'medium'"
            :title="'Vaste bedragen'"
			:payments="client.monthly_payments"
			:client_id="client.id">
		</c-monthly-payments>

		<c-generate-invoice
			v-show="modalGenerateInvoice"
			@close="modalGenerateInvoice=false">
		</c-generate-invoice>

	</div>
</template>

<script>
import View from '@mixins/View';
import Form from '@mixins/Form';
import CTable from '@components/table/Table';
import CBreadcrumbs from '@components/Breadcrumbs';
import { mapGetters } from 'vuex';

// blocks
import CBlockCompanyInfo from '@components/blocks/CompanyInfo';
import CBlockAddressbook from '@components/blocks/Addressbook';
import CBlockActivity from '@components/blocks/Activity';
import CBlockStock from '@components/blocks/Stock';
import CBlockInactiveStock from '@components/blocks/InactiveStock';
import CBlockProductPrices from '@components/blocks/ProductPrices';
import CBlockPrenotifications from '@components/blocks/PreNotifications';
import CMonthlyPayments from '@app/modals/MonthlyPayments';
import CBlockCustomers from '@components/blocks/Customers';

//modals
import CNewStock from '@app/modals/NewStock';
import CNewPrenotification from '@app/modals/NewPrenotification';
import CNewResignation from '@app/modals/NewResignation';
import CRepairRequest from '@app/modals/RepairRequest';
import CNewAddress from '@app/modals/NewAddress';
import CNewCustomer from '@app/modals/NewCustomer';
import CEolSwap from '@app/modals/EolSwap';
import COrderExtraProducts from '@app/modals/OrderExtraProducts';
import CImportAddresses from '@app/modals/ImportAddresses';
import CGenerateInvoice from '@app/modals/GenerateInvoice'
import CConfirmModal from '@app/modals/ConfirmModal';

export default {
	mixins: [ View, Form ],
	components: {
		CBreadcrumbs,
		CBlockCompanyInfo,
		CBlockAddressbook,
		CBlockActivity,
        CBlockStock,
		CBlockPrenotifications,
		CBlockCustomers,
        CNewStock,
		CBlockInactiveStock,
		CNewPrenotification,
		CConfirmModal,
		CNewResignation,
		CRepairRequest,
		CNewAddress,
		CNewCustomer,
		CEolSwap,
		COrderExtraProducts,
        CImportAddresses,
		CTable,
		CBlockProductPrices,
		CMonthlyPayments,
		CGenerateInvoice
	},
	data() {
		return {
            modalStock: false,
			modalInactiveStock: false,
			modalPrenotification: false,
			modalResignation: false,
			modelRepair: false,
			modelNewAddress: false,
			modalNewCustomer: false,
			modalEOl: false,
			modalExtraProducts: false,
            modalImportAddresses: false,
            contact: {},
            client: {},
			items: [],
			modalMonthlyPayments: false,
			modalGenerateInvoice: false,
			loading: false
		}
	},
	methods: {
		openModalStock() {
			this.modalStock = true;
		},
		openModalExtraProducts() {
			this.modalExtraProducts = true;
		},
		openModalPrenotification() {
			this.modalPrenotification = true;
		},
		openModalResignation() {
			this.modalResignation = true;
		},
		openModalRepair() {
			this.modelRepair = true;
		},
		openModalNewAddress() {
			this.modelNewAddress = true;
		},
		openModalNewCustomer() {
			this.modalNewCustomer = true;
		},
		openEolSwap() {
			this.modalEOl = true;
		},
        openModalImportAddresses() {
            this.modalImportAddresses = true;
        },
		openModalInactiveStock(){
			this.modalInactiveStock = true;
		},
     	openModalMonthlyPayments(){
			this.modalMonthlyPayments = true;
		},
		openModalGenerateInvoice(){
			this.modalGenerateInvoice = true;
		},
		load(){
			if(this.loading){
				return;
			}
			this.loading = true;
			this.$xhr.get('/api/clients/' + this.$route.params.id + '?minimum=true').then( ({result}) => {
				this.contact = result.primary_contact;
				this.client = result;
				this.items = result?.items;
				this.loading = false;
			}).catch((e) => {
				this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Klantgegevens kunnen niet worden ingeladen'});
			});
		},
		generateInvoice(){
			this.modalGenerateInvoice = true
		}
	},
	created() {
		this.$store.dispatch('listener/on', {
			event: 'new-stock',
			listener: this.openModalStock
		});

		this.$store.dispatch('listener/on', {
			event: 'extra-products',
			listener: this.openModalExtraProducts
		});

		this.$store.dispatch('listener/on', {
			event: 'eol-swap',
			listener: this.openEolSwap
		});

		this.$store.dispatch('listener/on', {
			event: 'new-prenotification',
			listener: this.openModalPrenotification
		});

		this.$store.dispatch('listener/on', {
			event: 'resignation',
			listener: this.openModalResignation,
		});

		this.$store.dispatch('listener/on', {
			event: 'repair',
			listener: this.openModalRepair,
		});

		this.$store.dispatch('listener/on', {
			event: 'new-address',
			listener: this.openModalNewAddress,
		});

		this.$store.dispatch('listener/on', {
			event: 'new-customer',
			listener: this.openModalNewCustomer,
		});

        this.$store.dispatch('listener/on', {
            event: 'import-customer-addresses',
            listener: this.openModalImportAddresses,
        });

        this.$store.dispatch('listener/on', {
            event: 'refresh-client-data',
            listener: this.load,
        });

		this.$store.dispatch('listener/on', {
            event: 'monthly-payments',
            listener: this.openModalMonthlyPayments,
        });	

		this.$store.dispatch('listener/on', {
            event: 'generate-invoice',
            listener: this.openModalGenerateInvoice,
        });	
		
	},
	beforeUnmount() {
		this.$store.dispatch('listener/off', {
			event: 'new-stock',
			listener: this.openModalStock
		});

		this.$store.dispatch('listener/off', {
			event: 'extra-products',
			listener: this.openModalExtraProducts
		});
		this.$store.dispatch('listener/off', {
			event: 'eol-swap',
			listener: this.openEolSwap
		});

		this.$store.dispatch('listener/off', {
			event: 'new-prenotification',
			listener: this.openModalPrenotification
		});

		this.$store.dispatch('listener/off', {
			event: 'resignation',
			listener: this.openModalResignation
		});

		this.$store.dispatch('listener/off', {
			event: 'repair',
			listener: this.openModalRepair
		});

		this.$store.dispatch('listener/off', {
			event: 'new-address',
			listener: this.openModalNewAddress
		});

		this.$store.dispatch('listener/off', {
			event: 'new-customer',
			listener: this.openModalNewCustomer
		});

        this.$store.dispatch('listener/off', {
            event: 'import-customer-addresses',
            listener: this.openModalImportAddresses,
        });

        this.$store.dispatch('listener/off', {
            event: 'refresh-client-data',
            listener: this.load,
        });

		this.$store.dispatch('listener/off', {
            event: 'monthly-payments',
            listener: this.openModalMonthlyPayments,
        });

		this.$store.dispatch('listener/off', {
            event: 'generate-invoice',
            listener: this.openModalGenerateInvoice,
        });	
	},
	computed: {
		deliveryAddresses() {
			return [...this.client.addresses ?? [], ...this.client.parent?.addresses ?? []];
		},
		...mapGetters({
			can: 'user/can',
			user: 'user/get'
		}),
	},
	watch: {
     '$route.params.id': {
        handler: function(id) {
			if(this.$route.name === 'customerDetail')
			{
				this.load();
			}
        },
        deep: true,
        immediate: true
      }
	},
	mounted(){
		this.load();
	}
}
</script>
